/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/no-danger */

import React from 'react'
import { convertToSlug } from 'src/utils/IdGenerator'
import ImageComponent from '@components/StepCards2Column/ImageComponent'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import NColumnGridCta from '@components/Button/button'
import { getHeadingDesc } from '@utils/schemaUtils'
import { HTMLTagsForHowTo } from '@configs/howToHTMLTag'
import CardItem from './cardItem'
import styles from './stepCards.module.scss'

const StepCards2Column = ({ data }) => {
  const stepData = data?.data?.attributes
  const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

  const heading = getHeadingDesc(stepData.sectionHeading)
  const isHowToComp =
    heading.heading.toLowerCase().includes('steps') || heading.heading.toLowerCase().includes('how to')
  const { WrapperTag } = HTMLTagsForHowTo.nStep(isHowToComp)

  const renderColumns = () => {
    if (stepData.TwoColumnLayoutType === 'StepCards in Column1 and Image in Column2') {
      return (
        <>
          <div className={styles.halfWidthContainer}>
            <form>
              <WrapperTag className={styles.fieldSet}>
                {stepData.twoColumnStepCardsWithImage.map((item, index) => (
                  <CardItem
                    key={`${item.id}${index}`}
                    item={item}
                    index={index}
                    fieldsetsCount={stepData.twoColumnStepCardsWithImage.length}
                    isHowToComp={isHowToComp}
                  />
                ))}
              </WrapperTag>
            </form>
          </div>
          <ImageComponent firstItem={stepData.twoColumnStepCardsWithImage[0]} />
        </>
      )
    }

    if (stepData.TwoColumnLayoutType === 'Image in Column1 and StepCards in Column2 ') {
      return (
        <>
          <ImageComponent firstItem={stepData.twoColumnStepCardsWithImage[0]} />
          <div className={styles.halfWidthContainer}>
            <form>
              <WrapperTag className={styles.fieldSet}>
                {stepData.twoColumnStepCardsWithImage.map((item, index) => (
                  <CardItem
                    key={`${item.id}${index}`}
                    item={item}
                    index={index}
                    fieldsetsCount={stepData.twoColumnStepCardsWithImage.length}
                    isHowToComp={isHowToComp}
                  />
                ))}
              </WrapperTag>
            </form>
          </div>
        </>
      )
    }

    // Default fallback or additional cases can be handled here
    return null
  }

  const getModifiedHtml = tableContent => {
    const $ = cheerio.load(tableContent, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  // for id assign
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = data?.data?.attributes.sectionHeading.match(h2Regex)
  const h2Content = matches ? matches[1] : null

  return (
    <ErrorBoundary data={data}>
      <div className={styles.stepCardsRootContainer} id={convertToSlug(h2Content)}>
        <div className={styles.colorBlendParent}>
          <div className={styles.colorBlendTopRightCircle} />
          <div className={styles.colorBlendBottomLeftCircle} />
        </div>

        <div className={styles.stepCardsMainContainer}>
          <div
            className={styles.sectionHeading}
            dangerouslySetInnerHTML={{ __html: getModifiedHtml(stepData.sectionHeading) }}
          />

          <div className={styles.halfWidthRootContainer}>{renderColumns()}</div>

          {stepData.sectionCta && (
            <div className={styles.sectionCta}>
              {stepData.sectionCta?.sectionCTAPara && (
                <div dangerouslySetInnerHTML={{ __html: getModifiedHtml(stepData.sectionCta?.sectionCTAPara) }} />
              )}
              <NColumnGridCta
                data={stepData.sectionCta}
                segmentEventCommonProperties={data?.segmentEventCommonProperties}
              />
            </div>
          )}
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default StepCards2Column
